/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ReplaceModelCatalogOrgAccessRequest = {
  orgId: string;
  accessMutationRequest: components.AccessMutationRequest;
};

/** @internal */
export const ReplaceModelCatalogOrgAccessRequest$inboundSchema: z.ZodType<
  ReplaceModelCatalogOrgAccessRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  AccessMutationRequest: components.AccessMutationRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "AccessMutationRequest": "accessMutationRequest",
  });
});
/** @internal */
export type ReplaceModelCatalogOrgAccessRequest$Outbound = {
  orgId: string;
  AccessMutationRequest: components.AccessMutationRequest$Outbound;
};

/** @internal */
export const ReplaceModelCatalogOrgAccessRequest$outboundSchema: z.ZodType<
  ReplaceModelCatalogOrgAccessRequest$Outbound,
  z.ZodTypeDef,
  ReplaceModelCatalogOrgAccessRequest
> = z.object({
  orgId: z.string(),
  accessMutationRequest: components.AccessMutationRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    accessMutationRequest: "AccessMutationRequest",
  });
});

export function replaceModelCatalogOrgAccessRequestToJSON(
  replaceModelCatalogOrgAccessRequest: ReplaceModelCatalogOrgAccessRequest,
): string {
  return JSON.stringify(
    ReplaceModelCatalogOrgAccessRequest$outboundSchema.parse(
      replaceModelCatalogOrgAccessRequest,
    ),
  );
}
export function replaceModelCatalogOrgAccessRequestFromJSON(
  jsonString: string,
): SafeParseResult<ReplaceModelCatalogOrgAccessRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ReplaceModelCatalogOrgAccessRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ReplaceModelCatalogOrgAccessRequest' from JSON`,
  );
}
